import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import { useTask } from "context/client/task";

import ModalNew from "components/ModalNew";

const CancelTaskModal = ({ title, isOpen, onClose }) => {
  const { t } = useTranslation();
  const { updateTask } = useTask();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setLoading(true);

      navigate("/tasks");

      await updateTask({ status: 7 });
      onClose();
      toast.error(t("The task was canceled."));
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <ModalNew
      title={t("Cancel task")}
      status="error"
      loading={!!loading}
      labelSubmit="Yes, close task"
      hasMobileScrollTop={false}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <p>
        {t("Are you sure you would like to cancel the task")}{" "}
        <strong>{title}</strong>?<br />
        <br />
        {t(
          "This action cannot be reversed. Before deleting the task please make sure it doesn't contain any important information.",
        )}
      </p>
    </ModalNew>
  );
};

export default CancelTaskModal;
